export const truncatedString = (str: string, from: number, length: number) => {
  if (str?.length > length) {
    return str.slice(from, from + length) + '...';
  }

  return str;
};
